function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
export default {
  components: {},
  emits: ['update:modelValue', 'change'],
  props: {
    modelValue: Array,
    label: String
  },
  data: function data() {
    return {
      inputval: '',
      inputArr: this.modelValue
    };
  },
  watch: {
    modelValue: function modelValue() {
      this.inputArr = this.modelValue;
    }
  },
  methods: {
    addInput: function addInput() {
      if (!this.inputval) return;
      this.inputArr.push(this.inputval.replace(/[,;]/g, '')); //replace , and ;
      this.inputval = '';
      this.$emit('update:modelValue', _toConsumableArray(this.inputArr));
      this.$emit('change');
    },
    deleteTag: function deleteTag(tagIndex) {
      this.inputArr.splice(tagIndex, 1);
      this.$emit('update:modelValue', _toConsumableArray(this.inputArr));
      this.$emit('change');
    }
  }
};